/*
 *    Copyright (c) 2018-2025, lengleng All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * Redistributions of source code must retain the above copyright notice,
 * this list of conditions and the following disclaimer.
 * Redistributions in binary form must reproduce the above copyright
 * notice, this list of conditions and the following disclaimer in the
 * documentation and/or other materials provided with the distribution.
 * Neither the name of the pig4cloud.com developer nor the names of its
 * contributors may be used to endorse or promote products derived from
 * this software without specific prior written permission.
 * Author: lengleng (wangiegie@gmail.com)
 */

import request from '@/api/axios';
/** *
 * 停用指定的业务员
 * @param id
 * @param disabled
 */
export function findPageBySalesmanId(data) {
  return request({
    url: '/cust/cust/findPageBySalesmanId',
    method: 'post',
    data,
  });
}

/** *
 * 查询注册客户
 * @param comBm
 * @param beginDate
 * @param endDate
 */
export function findRegList(comBm, beginDate, endDate) {
  return request({
    url: `/cust/cust/findRegList?comBm=${comBm}&beginDate=${beginDate}&endDate=${endDate}`,
    method: 'post',
  });
}

/** *
 * 导出注册用户
 * @param comBm 公司编码
 * @param beginDate 开始时间
 * @param endDate 结束时间
 */
export function exportRegLiexportRegListst(comBm, beginDate, endDate) {
  request({
    url: `/cust/cust/exportRegList?comBm=${comBm}&beginDate=${beginDate}&endDate=${endDate}`,
    method: 'get',
    responseType: 'blob',
  }).then((response) => {
    console.log(response.data);
    const blob = new Blob([response.data], {
      type: 'application/vnd.ms-excel',
    });
    console.log(blob);
    const fileName = `${Date.parse(new Date())}.xlsx`;
    if (window.navigator.msSaveOrOpenBlob) {
      console.log(2);
      navigator.msSaveBlob(blob, fileName);
    } else {
      console.log(3);
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
      // 释放内存
      window.URL.revokeObjectURL(link.href);
    }
  });
}

/** *
 * 查询客户列表
 * @param comBm 公司编码
 * ...
 */

export function getCustList(param) {
  return request({
    url:
    // `http://10.10.31.60:6052/cust/l_custList?`
         '/cust/cust/l_custList?'
        + `pageSize=${param.pageSize}`
        + `&pageNum=${param.pageNum}`
        + `&companyBm=${param.comBm}`
        + `&custType=${param.custType}`
        + `&schKeyword=${param.schKeyword}`
        + `&registeredBeginAddTime=${param.registeredBeginAddTime}`
        + `&registeredEndAddTime=${param.registeredEndAddTime}`
        + `&enableBeginTime=${param.enableBeginTime}`
        + `&enableEndTime=${param.enableEndTime}`
        + `&ssvrSwManId=${param.ssvrSwManId}`
        + `&nsalemanId=${param.nsalemanId}`,
    method: 'get',
  });
}

/** *
 * 根據父id查询客户列表子层
 * @param mainId
 * ...
 */

export function getCustListByMainid(mainId) {
  return request({
    url: `/cust/cust/l_custListgetChilds?mainId=${mainId}`,
    method: 'get',
  });
}

/** *
 * 获取商务列表下拉菜单
 * @param comBm
 */
export function getSwList(comBm) {
  return request({
    url: `/user/user/l_fndUserByComBm?comBms=${comBm}`,
    method: 'get',
    noNProgress: true,
  });
}

/** *
 * 获取业务列表下拉菜单
 * @param comBm
 */
export function getYwList(comBm) {
  return request({
    url: `/user/user/l_fndYwByComBm?comBms=${comBm}`,
    method: 'get',
    noNProgress: true,
  });
}

/** *
 * 导出客户列表（触发）dsvr
 * @param mainId
 * ...
 */

export function exportCustList(param) {
  return request({
    url: '/cust/cust/l_exportCust4Excel?'
      + `pageSize=${param.pageSize}`
      + `&pageNum=${param.pageNum}`
      + `&companyBm=${param.comBm}`
      + `&custType=${param.custType}`
      + `&schKeyword=${param.schKeyword}`
      + `&registeredBeginAddTime=${param.registeredBeginAddTime}`
      + `&registeredEndAddTime=${param.registeredEndAddTime}`
      + `&enableBeginTime=${param.enableBeginTime}`
      + `&enableEndTime=${param.enableEndTime}`
      + `&ssvrSwManId=${param.ssvrSwManId}`
      + `&nsalemanId=${param.nsalemanId}`,
    method: 'get',
  });
}

/** *
 * 导出客户列表（触发）按需导出
 * @param mainId
 * ...
 */

export function exportCustListBySelect(param) {
  return request({
    url: '/cust/cust/l_exportCust4Excel?'
      + `ids=${param}`,
    method: 'get',
  });
}

/** *
 * 导出客户列表
 * @param mainId
 * ...
 */

export function exportCustContent(data) {
  return request({
    url: `/cust/cust/l_exportCust4ExcelDowdnload?flag=${data}`,
    method: 'get',
  });
}

/** *
 * 查询分公司列表
 */
export function getSubComList(param) {
  return request({
    url: '/cust/company/l_findByPage?'
      + `pageSize=${param.pageSize}`
      + `&pageNum=${param.pageNum}`
      + `&companyBm=${param.companyBm}`
      + `&companyName=${encodeURIComponent(param.companyName)}`,
    method: 'get',
  });
}

/** *
 * 获取客户企业信息资质图片
 */
export function getAuthPicture(param) {
  return request({
    url: `/cust/cust/l_getAuthPicture?userId=${param}`,
    method: 'get',
  });
}

/** *
 * 审核客户
 */
export function auditCust(param) {
  return request({
    url: `/cust/cust/l_customerAudit?custId=${param.necCustId}&type=${param.type}&companyBm=${param.companyBm}&parameter=${param.parameter}`,
    method: 'get',
  });
}

/** *
 * 客户审核检验
 */
export function auditCustCheck(param) {
  return request({
    url: `/cust/cust/l_customerAuditCheck?custId=${param.necCustId}&parameter=${param.parameter}&companyBm=${param.companyBm}`,
    method: 'get',
  });
}

/** *
 * 临时通过客户
 */
export function auditAnoCust(param) {
  return request({
    url: `/cust/cust/l_activateCustomer?nuserid=${param}`,
    method: 'get',
  });
}

/** *
 * 生成推广卡
 */
export function createCard(param) {
  return request({
    url: `/cust/promote/p_createCard?name=${param.name}&account=${param.account}&pwd=${param.pwd}`,
    method: 'get',
  });
}

/** *
 * 解除关联关系
 */
export function dissRelaship(param) {
  return request({
    url: `/cust/fe/user/removeCorrelation/l_childAccount?userId=${param}&type=ODS`,
    method: 'get',
  });
}

/** *
 * 生成推广链接
 */
export function createCardUrl(param) {
  return request({
    url: `/cust/promote/p_createLink?name=${param.scustName}&account=${param.secCustAccount}&pwd=${param.secInitPwd}`,
    method: 'get',
  });
}

/** *
 * 开通账号
 */
export function createAccount(param) {
  return request({
    url: `/cust/cust/l_openAccount?custIdList=${param}`,
    method: 'post',
  });
}

/** *
 * 查询客户列表
 */
export function getCustomerPage(param) {
  return request({
    url: '/cust/cust/l_getCustomerPage?'
      + `schKeyword=${encodeURIComponent(param.schKeyword)}`
      + `&pageSize=${param.pageSize}`
      + `&pageNum=${param.pageNum}`,
    method: 'get',
  });
}

/** *
 * 根据产品系列/别名搜索产品
 */
export function querySeries(param) {
  return request({
    url: '/discount/prop/l_serach?'
      + `parameter=${encodeURIComponent(param.parameter)}`
      + `&pageSize=${param.pageSize}`
      + `&pageNum=${param.pageNum}`,
    method: 'get',
  });
}

/** *
 * fbj折扣通知条数
 */
export function getFbjNoticeNum(empId) {
  return request({
    url: `/discount/FBJ-discount/l_getFbjDiscountNoticeSize?empId=${empId}`,
    method: 'get',
  });
}

/** *
 * 查询品牌列表
 */
export function getBrandList() {
  return request({
    url: '/discount/brand/l_brandList',
    method: 'get',
  });
}

/** *
 * 查询系列列表
 */
export function getSeriesList(brandId) {
  return request({
    url: `/discount/prop/l_propList?brandId=${brandId}`,
    method: 'get',
  });
}
/** *
 * 查询折扣系列相关接口(mock)
 */
// export function getSeriesDiscountList(brandId) {
//   return request({
//     // url:`/discount//prop/l_propList?brandId=${brandId}`,
//     url:`/discountListMock`,
//     method:'get'
//   })
// }

/** *
 * 系列折扣搜索列表
 */
export function getSeriesDiscountList(param) {
  return request({
    url: '/discount/discount/l_getSeriesDiscountList?'
      + `pageNum=${param.pageNum}`
      + `&pageSize=${param.pageSize}`
      + `&brandId=${param.brandId}`
      + `&seriesId=${param.seriesId}`
      + `&alias=${encodeURIComponent(param.alias)}`
      + `&custId=${param.custId}`
      + `&disSort=${param.disSort}`,
    method: 'get',
  });
}

/** *
 * 修改系列折扣
 */
export function updateSeriesDiscount(userid, data) {
  return request({
    url: '/discount/discount/l_updateSeriesDiscount',
    method: 'post',
    data,
  });
}

/** *
 * 批量保存折扣设置
 */
export function updateCatDiscount(userid, data) {
  return request({
    url: '/discount/discount/l_save',
    method: 'post',
    data,
  });
}
/** *
 * 保存FBJ折扣设置
 */
export function updateFbjDiscount(data) {
  return request({
    url: '/discount/FBJ-discount/l_save',
    method: 'post',
    data,
  });
}

/** *
 * 获取已发送通知列表
 */
export function fndListOfNotify(param) {
  return request({
    url: '/discount/FBJ-discount/l_fndListOfNotify?'
      + `pageNum=${param.pageNum}`
      + `&pageSize=${param.pageSize}`,
    method: 'get',
  });
}

/** *
 * 系列搜索
 */
export function queryListOfSeries(param) {
  return request({
    url: '/discount/FBJ-discount/l_listOfSeries?'
      + `keyWord=${encodeURIComponent(param.keyWord)}`
      + `&pageNum=${param.pageNum}`
      + `&pageSize=${param.pageSize}`,
    method: 'get',
  });
}

/** *
 * 查询对应品牌、系列下的 FBJ 折扣列表
 */
export function getFbjSeriesList(param) {
  return request({
    url: '/discount/FBJ-discount/l_list?'
      + `brandId=${param.brandId}`
      + `&seriesId=${encodeURIComponent(param.seriesId)}`,
    method: 'get',
  });
}

/** *
 * fbj折扣通知列表
 */
export function getFbjDiscountNoticeList(param) {
  return request({
    url: '/discount/FBJ-discount/l_getFbjDiscountNoticeList?'
      + `pageNum=${param.pageNum}`
      + `&pageSize=${param.pageSize}`
      + `&empId=${param.empId}`
      + `&status=${param.status}`,
    method: 'get',
  });
}

/** *
 * 保存已读状态（标记为已读）
 */
export function saveReadStatus(param) {
  return request({
    url: '/discount/FBJ-discount/l_saveReadStatus',
    method: 'post',
    data: param,
  });
}

/** *
 * fbj折扣通知上调、下调数量
 */
export function getFbjDiscountNoticeNum(param) {
  return request({
    url: '/discount/FBJ-discount/l_getFbjDiscountNoticeNumByEmp',
    method: 'post',
  });
}

/* 折扣复制页 */

/** *
 * fbj折扣通知上调、下调数量
 */
export function queryCustList(param) {
  return request({
    url: '/cust/cust/l_allCustList?'
      + `pageNum=${param.pageNum}`
      + `&pageSize=${param.pageSize}`
      + `&schKeyword=${encodeURIComponent(param.schKeyword)}`
      + `&id=${param.id}`,
    // `&companyBm=${param.companyBm}`,
    method: 'get',
  });
}

/** *
 * 根据userid获取折扣信息--(折扣复制列表)
 */
export function getUserDisForDisCopy(param) {
  return request({
    url: '/discount/discount/l_getUserDisForDisCopy?'
      + `pageNum=${param.pageNum}`
      + `&pageSize=${param.pageSize}`
      + `&custId=${param.custId}`,
    method: 'post',
  });
}

/** *
 * 复制保存折扣设置
 */
export function copyDiscount(param) {
  return request({
    url: '/discount/discount/l_copy?'
      + `source_custId=${param.source_custId}`
      + `&target_custIds=${param.target_custIds}`,
    method: 'post',
  });
}

// 支付管理页面列表接口
export function getPayList(param) {
  return request({
    // url:
    //     `http://127.0.0.1:6003/payManage/l_getPayManageList?`
    //     +`companyBms=${param.companyBms}`
    //     +`&spayType=${param.spayType}`
    //     +`&stype=${param.stype}`
    //     +`&dcreateTimeStart=${param.dcreateTimeStart}`
    //     +`&dcreateTimeEnd=${param.dcreateTimeEnd}`
    //     +`&npaidAmountStart=${param.npaidAmountStart}`
    //     +`&npaidAmountEnd=${param.npaidAmountEnd}`
    //     +`&credentials=${param.credentials}`
    //     +`&cust=${param.cust}`
    //     +`&payAccount=${param.payAccount}`
    //     +`&pageNum=${param.pageNum}`
    //     +`&pageSize=${param.pageSize}`
    //     +`&sort=${param.sort}`
    //     +`&order=${param.order}`,
    url: `pay-center/payManage/l_getPayManageList?${param}`,
    // url:'/pay-center/payManage/l_getPayManageList?'+param,
    method: 'get',
  });
}

// 支付管理页面支付方式，支付类型下拉值
export function payType() {
  // debugger
  return request({
  //  url: `/pay-center/payManage/l_dropDownList`,
    url: 'pay-center/payManage/l_dropDownList',
    method: 'get',
  });
}

// excel 导出接口  触发下载，返回一个序列号
export function downloadNum(param) {
  return request({
  //  url: `/pay-center/payManage/l_dropDownList`,
    url: `pay-center/payManage/l_exportDealList?${param}`,
    method: 'get',
  });
}

// excel 导出接口  通过一个序列号导出excel
export function downloadExcel(param) {
  return request({
    url: `pay-center/payManage/l_exportDealListDowload?${param}`,
    method: 'get',
  });
}

// excel 导出接口  触发下载，返回一个序列号
export function loopApi(param) {
  return request({
  //  url: `/pay-center/payManage/l_dropDownList`,
    url: `${location.origin}/service/pay-center/payManage/l_exportDealListDowload?flag=${param}`,
    method: 'get',
  });
}

// 微信申请退款
export function wxRefund(param) {
  return request({
    url: 'pay-center/wxPay/a_orderRefund',
    method: 'post',
    data: param,
  });
}

// 银联申请退款
export function unionRefund(param) {
  return request({
    url: `pay-center/cmbcPay/a_cmbcRefund?${param}`,
    method: 'get',
  });
}

// 支付宝申请退款
export function alipayRefund(param) {
  return request({
    url: 'pay-center/aliPay/a_aliOrderRefund',
    method: 'post',
    data: param,
  });
}

// 编辑备注
export function toRemark(param) {
  return request({
    url: `pay-center/payManage/a_editorsNote?${param}`,
    method: 'get',
  });
}
// 账号管理
// 查询用户信息
export function getUserList(param) {
  return request({
    url:
      `/cust/cust/a_findUserInfoList?name=${param.name === null ? '' : param.name}&pageSize=${param.pageSize}&pageNum=${param.pageNum}`,
    method: 'get',
  });
}

/**
 * 修改密码
 * @param data
 */
export function modifypass(data) {
  return request({
    url: '/cust/cust/a_updatePwdByAdminSelect',
    method: 'post',
    data,
  });
}

/**
 * 注销
 * @param data
 */
export function canelcount(data) {
  return request({
    url: '/cust/cust/a_unsubscribeByAdminSelect',
    method: 'post',
    data,
  });
}
/**
 * 解绑手机
 * @param data
 */
export function unbindphone(data) {
  return request({
    url: '/cust/cust/a_removePhoneByAdminSelect',
    method: 'post',
    data,
  });
}
/**
 * 解绑手机查看是否有审核中合同
 * @param data
 */
export function isHaveAuditSeal(userid) {
  return request({
    url: `/order/auth/l_isHaveAuditSeal?userId=${userid}`,
    method: 'get',
  });
}
/**
 * 解绑微信
 * @param data
 */
export function unbindwechat(data) {
  return request({
    url: '/cust/wx/a_removeWechatByAdminSelect',
    method: 'post',
    data,
  });
}
/**
 * 查询是否有签章
 * @param data
 */
export function checkHaveSealNew(userid) {
  return request({
    url: `/order/auth/l_checkHaveSealNew?userId=${userid}`,
    method: 'get',
  });
}
/**
 * 查询是否有生效中的电子签章
 * @param data
 */
export function checkHaveLifeSeal(userid) {
  return request({
    url: `/order/auth/l_checkHaveLifeSeal?userId=${userid}`,
    method: 'get',
  });
}
/**
 * 查看记录
 * @param data
 */
export function queryrecord(id) {
  return request({
    url: `/cust/cust/a_findUserRecordList?userId=${id}`,
    method: 'get',
  });
}

export function getActKey(query) {
  return request({
    url: '/cust/activity/login/l_saveActivityInfo',
    method: 'post',
    data: query,
  });
}
/**
 * 停用
 * @param data
 */
export function disabledAccount(data) {
  return request({
    url: '/cust/cust/a_disabledAccountByUserId',
    method: 'post',
    data,
  });
}
/**
 * 启用
 * @param data
 */
export function enabledAccount(data) {
  return request({
    url: '/cust/cust/a_enabledAccountByUserId',
    method: 'post',
    data,
  });
}

// 退款审核页面列表
export function getRefundList(param) {
  return request({
    url: 'order/order/a_findOrderRefundAuditList',
    method: 'post',
    data: param,
  });
}

// 退款审核页面-获取商务人员
export function getMember(comBm) {
  return request({
    url: `/user/person/l_fndBusManListByCom?comBm=${comBm}`,
    method: 'get',
  });
}

// 退款审核页面-审核退款
export function isRefundApi(param) {
  return request({
    url: 'order/order/a_orderRefundManagerAudit',
    method: 'post',
    data: param,
  });
}

// 退款审核页面-tab number
export function getRefundTabNumber(param) {
  return request({
    url: 'order/order/l_findOrderRefundLabelNum',
    method: 'post',
    data: param,
  });
}

/**
 * 企业微信客户 获取列表
 */
export function getqyWechatList(data) {
  return request({
    url: '/cust/cust/l_findCoWeChatCustList',
    method: 'post',
    data,
  });
}

/** *
 * 企业微信客户 导出
 * ...
 */

export function exportQyWechatList(param) {
  return request({
    url: `/cust/cust/l_exportCoWeChatCust?searchKey=${param.searchKey}&startTime=${param.beginTime}&endTime=${param.endTime}&status=${param.status}`,
    method: 'get',
  });
}

/** **
 * 获取企业标签库
 * @param data
 */
export function getCorpTags(id) {
  return request({
    url: `/cust/cust/l_getCorpTags?tagGroupName=${id}`,
    method: 'post',
  });
}
/**
 * 企业微信客户 获取角标
 */
export function getqyWebadgeNum(data) {
  return request({
    url: '/cust/cust/l_badgeNum',
    method: 'post',
    data,
  });
}
/**
 * 编辑企业微信客户内容
 */
export function editRemarkData(data) {
  return request({
    url: '/cust/cust/l_editRemarkInfo',
    method: 'post',
    data,
  });
}
/**
 * 下载导入结果
 */
export function exportCoWeChatEditRet(data) {
  return request({
    url: '/cust/cust/l_exportCoWeChatEditRet',
    method: 'post',
    data,
  });
}

/**
 * 获取省市区
 */
export function getIpApiJson(param) {
  return request({
    url: `/cust/addr/p_getAddrInfo?ncityId=${param}`,
    method: 'get',
  });
}
